import { render, staticRenderFns } from "./showEntrepreneurshipsEdition.vue?vue&type=template&id=29794ed7"
import script from "./showEntrepreneurshipsEdition.vue?vue&type=script&lang=js"
export * from "./showEntrepreneurshipsEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports